import emojiRegex from 'emoji-regex';

export const emojiInString = (text: string) => {
  const regex = emojiRegex();
  return text.match(regex);
};
